// extracted by mini-css-extract-plugin
export default {"container":"locked_container__18Ej2","title":"locked_title__JBAZD"};